import { createAction, createSlice, } from "@reduxjs/toolkit";
import { set } from "react-hook-form";
const initialState = {
    loading: true,
    error: "",
    gradeDetails: {},
    current: {},
    pagination: {},
    gradingModelList :[],
};

export const gradeSlice = createSlice({
    name: "gradeDetails",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.loading = action.payload;
        },
        setGrade(state, action) {
            let data = action.payload;
            state.gradeDetails = data;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        deleteGrade(state, action) {
            let { id } = action.payload;
            state.gradeDetails.data = state.gradeDetails.data.filter(e => e.id != id);
        },
        setCurrentGrade(state, action) {
            state.current = action.payload;
            state.loading = false;
        },
        setGradingModelList(state, action) {
            // Dedupe by id so revisiting the page doesn't accumulate duplicates.
            // Callers pass the full filtered list each time, so we merge by id
            // (existing entries are replaced by the latest payload).
            const merged = new Map(
                (state.gradingModelList || []).map((item) => [item.id, item])
            );
            (action.payload || []).forEach((item) => {
                if (item && item.id != null) merged.set(item.id, item);
            });
            state.gradingModelList = Array.from(merged.values());
            state.loading = false;
        },
    },
});

export const gradeActions = {
    loadGrade: createAction(`${gradeSlice.name}/loadGrade`, (payload) => ({ payload })),
    loadCurrentGrade: createAction(`${gradeSlice.name}/changeCurrentGrade`, (payload) => ({ payload })),
    saveCurrentGrade: createAction(`${gradeSlice.name}/saveGrade`, (payload) => ({ payload })),
    createGrade: createAction(`${gradeSlice.name}/createGrade`, (payload) => ({ payload })),
    removeGrade: createAction(`${gradeSlice.name}/removeGrade`, (payload) => ({ payload })),
    updateStatus: createAction(`${gradeSlice.name}/updateStatus`, (payload) => ({ payload })),
   
    deleteGrade: gradeSlice.actions.deleteGrade,
    setGrade: gradeSlice.actions.setGrade,
    setCurrentGrade: gradeSlice.actions.setCurrentGrade,
    setGradingModelList: gradeSlice.actions.setGradingModelList,
    setSection: gradeSlice.actions.setSection,
    setChapter: gradeSlice.actions.setChapter,
    setGroup: gradeSlice.actions.setGroup

};
export const getGrade = (state) => state.grade.gradeDetails;
export const getCurrentGrade = (state) => state.grade.current;
export const isLoading = (state) => state.grade.loading;
export const getPagination = (state) => state.grade.pagination;
export const getGradingModelList = (state) => state.grade.gradingModelList;
export const getHasMore = (state) => state.grade.hasMore;
export const getPage = (state) => state.grade.page;

export default gradeSlice.reducer;
